import { DOCUMENT } from '@angular/common';
import {
    AfterViewInit,
    Component,
    ElementRef,
    Inject,
    OnDestroy,
    OnInit,
    ViewChild,
} from '@angular/core';
import { NavigationEnd, Router, RouterOutlet } from '@angular/router';
import { ConfigService } from '@polaris-customerweb/sharedcomponents.config';
import { defer } from 'lodash-es';
import { filter, startWith, takeWhile } from 'rxjs';
import { HeaderHeightService } from 'src/app/services/header-height.service';
import { MainHeaderComponent } from '../header/main-header.component';

@Component({
    imports: [MainHeaderComponent, RouterOutlet],
    selector: 'rdx-standard-layout',
    standalone: true,
    styleUrls: ['./standard-layout.component.scss'],
    templateUrl: './standard-layout.component.html',
})
export class StandardLayoutComponent
    implements OnInit, AfterViewInit, OnDestroy
{
    @ViewChild('contentContainer') private content: ElementRef<HTMLDivElement>;

    isOffRoad: boolean;
    showFooter = true;
    private isDestroyed = false;
    private footerElement: HTMLElement;

    constructor(
        private configService: ConfigService,
        @Inject(DOCUMENT) private document: Document,
        private headerHeight: HeaderHeightService,
        private router: Router
    ) {
        this.footerElement = this.document.querySelector(
            'footer.global-footer__wrapper'
        ) as HTMLElement;
    }

    ngOnInit(): void {
        this.isOffRoad = this.configService.isOffRoad;
        this.router.events
            .pipe(
                filter((e) => e instanceof NavigationEnd),
                startWith(this.router),
                takeWhile(() => !this.isDestroyed)
            )
            .subscribe((event) => {
                this.showFooter = !(event as NavigationEnd).url.startsWith(
                    '/map'
                );
                if (this.footerElement) {
                    this.footerElement.hidden = !this.showFooter;
                }
            });
    }
    ngOnDestroy(): void {
        this.isDestroyed = true;
        if (this.footerElement) {
            this.footerElement.hidden = false;
        }
    }

    ngAfterViewInit(): void {
        defer(() => {
            if (this.content) {
                this.headerHeight.update(this.content.nativeElement);
            }
        });
    }
}
